module.exports = __webpack_public_path__ + "img/consult_info3.c917b17d.png";